import tooltipDirective from "@/directives/tooltip/index.js"

const directives = (app) => {
  tooltipDirective(app)
}

export default directives
